module.exports = __webpack_public_path__ + "img/instagram-icon-dark.832b763f.svg";